import {
  PictureProperty,
  CurrentRoomImages,
  RoomImage,
  PrivateOfficeUpdateField,
} from "@/services/private-office-service/types";

export const IMAGE_PROPERTIES: PictureProperty[] = [
  "picture_url",
  "picture_url_1",
  "picture_url_2",
  "picture_url_3",
  "picture_url_4",
  "picture_url_5",
];

export const IMAGE_PROPERTY_NAMES: Record<PictureProperty, string> = {
  picture_url: "Imagem Principal",
  picture_url_1: "Imagem galeria",
  picture_url_2: "Imagem galeria",
  picture_url_3: "Imagem galeria",
  picture_url_4: "Imagem galeria",
  picture_url_5: "Imagem galeria",
};

export const convertToRoomImageArray = (
  currentImages: CurrentRoomImages,
): RoomImage[] => {
  return Object.entries(currentImages).map(([property, url]) => ({
    property: property as PictureProperty,
    url,
    name: IMAGE_PROPERTY_NAMES[property as PictureProperty],
    isEmpty: !url,
  }));
};

export const extractImagesFromOfficeInfo = (officeInfo: {
  [key: string]: any;
}): CurrentRoomImages => {
  const images: CurrentRoomImages = {
    picture_url: officeInfo.picture_url || null,
    picture_url_1: officeInfo.picture_url_1 || null,
    picture_url_2: officeInfo.picture_url_2 || null,
    picture_url_3: officeInfo.picture_url_3 || null,
    picture_url_4: officeInfo.picture_url_4 || null,
    picture_url_5: officeInfo.picture_url_5 || null,
  };
  return images;
};

export const getNewImageUrl = (
  fieldsToUpdate: PrivateOfficeUpdateField,
): string => {
  for (const property of IMAGE_PROPERTIES) {
    if (fieldsToUpdate[property]) {
      return fieldsToUpdate[property] as string;
    }
  }

  throw new Error("Nenhuma URL de imagem encontrada na solicitação");
};

export const isImageRequest = (
  fieldsToUpdate: PrivateOfficeUpdateField,
): boolean => {
  const updateFields = Object.keys(fieldsToUpdate);
  return updateFields.some((field) =>
    IMAGE_PROPERTIES.includes(field as PictureProperty),
  );
};

export const isImageDeletionRequest = (
  fieldsToUpdate: PrivateOfficeUpdateField,
): boolean => {
  for (const property of IMAGE_PROPERTIES) {
    if (property in fieldsToUpdate && fieldsToUpdate[property] === null) {
      return true;
    }
  }
  return false;
};

export const getImageDeletionProperty = (
  fieldsToUpdate: PrivateOfficeUpdateField,
): PictureProperty | null => {
  for (const property of IMAGE_PROPERTIES) {
    if (property in fieldsToUpdate && fieldsToUpdate[property] === null) {
      return property;
    }
  }
  return null;
};

export const getPreviousImageUrl = (
  previousValues: PrivateOfficeUpdateField | null,
): string | null => {
  if (!previousValues) return null;

  for (const property of IMAGE_PROPERTIES) {
    if (previousValues[property]) {
      return previousValues[property] as string;
    }
  }

  return null;
};

export const getRequestImageProperty = (
  fieldsToUpdate: PrivateOfficeUpdateField,
): PictureProperty | null => {
  return (
    IMAGE_PROPERTIES.find((property) => property in fieldsToUpdate) ?? null
  );
};
